import { xmlDecl, el } from './index.js';
import { NS } from '../ns.js';
import type { DocumentMeta } from '../../../types.js';

export function generateVersionXml(meta: DocumentMeta): string {
  return (
    xmlDecl() +
    '\n' +
    el('hc:version', {
      'xmlns:hc': NS.hc,
      'xmlns:ha': NS.ha,
      tagtypes: '1',
    },
      '\n' +
      el('ha:app', {}, 'hwpx-js') +
      '\n' +
      el('ha:appversion', {}, meta.hwpVersion) +
      '\n' +
      el('hc:version', { tagtypes: '0' },
        el('ha:major', {}, '1') +
        el('ha:minor', {}, '4'),
      ) +
      '\n',
    )
  );
}
